import { useEffect } from "react";
import ChessButton from "../../visual/ChessButton/ChessButton";
import useSoundEffect from "../../../hooks/useSoundEffect";
import { setActiveRow, setActiveCol, KeyCodes } from "../../../utils/navigationHelpers";
import "./PuzzleIncorrectMove.scss";

interface PuzzleIncorrectMoveProps {
    onRetry: () => void;
}

/**
 * PuzzleIncorrectMove component
 * Modal shown when player makes an incorrect move in puzzle mode
 * @param onRetry - Function to reset puzzle to previous state
 */
export default function PuzzleIncorrectMove({ onRetry }: PuzzleIncorrectMoveProps) {
    const { playClickAudio } = useSoundEffect();

    // Set focus on "Retry" button when modal opens
    useEffect(() => {
        setActiveRow(0);
        setActiveCol(0);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (KeyCodes.Ups.includes(event.key) || KeyCodes.Downs.includes(event.key)) {
                playClickAudio();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [playClickAudio]);

    return (
        <div className="puzzle-incorrect-move" data-testid="puzzle-incorrect-move">
            <h2>Incorrect move made. Try again!</h2>
            <div className="puzzle-incorrect-move-buttons">
                <ChessButton data-navrow={0} data-navcol={0} autoFocus onClick={onRetry}>
                    Retry
                </ChessButton>
            </div>
        </div>
    );
}
